<label class="text-label text-surface-500" for="income">
  {{ 'common.forms.annualHouseholdIncome' | transloco }}
</label>

<p-selectButton
  styleClass="custom-toggle-button"
  id="income"
  [dt]="dt"
  [unselectable]="false"
  [allowEmpty]="false"
  [formControl]="control()"
  [options]="incomeOptions"
  optionLabel="label" optionValue="value"/>
